import { AnimatedSection } from "./AnimatedSection";

const steps = [
  { num: "01", title: "Apply for access", desc: "Submit your application with trade credentials." },
  { num: "02", title: "Get verified", desc: "Our team reviews and approves qualified participants." },
  { num: "03", title: "View or publish listings", desc: "Access structured supply or list your products." },
  { num: "04", title: "Submit and manage deals", desc: "Move from interest to execution efficiently." },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-[#09120D]" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
            How It Works
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-3xl">
            Simple, controlled, effective
          </h2>
        </AnimatedSection>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((step, i) => (
            <AnimatedSection key={i} delay={i * 0.12}>
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 h-full hover:border-[#22C55E]/50 transition-colors duration-300 relative">
                <span className="font-['Outfit'] text-5xl font-bold text-[#22C55E]/15 absolute top-4 right-6">
                  {step.num}
                </span>
                <div className="relative z-10">
                  <span className="text-[#22C55E] font-['Outfit'] text-sm font-semibold">
                    Step {step.num}
                  </span>
                  <h3 className="font-['Outfit'] text-lg font-semibold text-white mt-3">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-[#A1B2A8] text-sm leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
